import 'rxjs'
import { createBrowserHistory } from 'history'
import { createInjectableStore } from './core/InjectableStore'
import { routerReducer, routerMiddleware } from 'react-router-redux'
import reducers from './reducers'

import * as services from './services'

export const history = createBrowserHistory()
export const store = createStore()

function createStore() {
  const initialReducers = Object.assign({}, reducers, {
    router: routerReducer
  })

  const { authService, restClient } = services
  const loggedIn = authService.getAuthInfoFromCache()

  const initialState = {
    loggedIn: !!loggedIn
  }

  const middleware = [routerMiddleware(history)]

  const injectableStore = createInjectableStore(
    initialReducers,
    initialState,
    middleware)

  restClient.injectDispatcher(injectableStore.dispatch)

  return injectableStore
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store.ts